import { getEnumValues } from './get-enum-values';
/**
 * Supported Customer Countries. Determines a customer's plans
 */
export enum CustomerCountry{
	US="US",
	CA="CA",
}
export const CustomerCountryValues = getEnumValues<CustomerCountry>(CustomerCountry);